module.exports = __webpack_public_path__ + "img/_ABS9725.e34bdf8f.jpg";